import type { RouteRecordRaw } from "vue-router";

export const worksheetRoutes: RouteRecordRaw[] = [
  {
    path: "/worksheet/info",
    name: "worksheet-info",
    component: () => import("./info.vue"),
  },
  {
    path: "/worksheet/wizard/info",
    name: "worksheet_wizard-info",
    component: () => import("./wizard/info.vue"),
  },
  {
    path: "/worksheet/worksheets",
    name: "worksheet-index",
    component: () => import("./worksheets/WorksheetListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "worksheet",
      title: "tools_meta.worksheet_prefix",
    },
    children: [
      {
        path: "import-from-to-teach",
        name: "worksheet-import-from-to-teach",
        component: () => import("./worksheets/import-from-to-teach/index.vue"),
        meta: {
          requiresAuth: true,
          namespace: "worksheet",
          title: "tools_meta.worksheet_prefix",
        },
      },
      {
        path: "import-from-to-teach/:worksheetId",
        name: "worksheet-import-from-to-teach-direct",
        component: () =>
          import("./worksheets/import-from-to-teach/[worksheetId].vue"),
        meta: {
          requiresAuth: true,
          namespace: "worksheet",
          title: "tools_meta.worksheet_prefix",
        },
      },
    ],
  },
  {
    path: "/worksheet/worksheets/new",
    name: "worksheet-new",
    component: () => import("./worksheets/new/WorksheetNewPage.vue"),
    meta: {
      requiresAuth: true,
      title: "tools_meta.worksheet_prefix",
    },
  },
  {
    path: "/worksheet/worksheets/:id",
    name: "worksheet-show",
    component: () => import("./worksheets/WorksheetLayout.vue"),
    meta: {
      requiresAuth: true,
      title: "tools_meta.worksheet_prefix",
    },
    children: [
      {
        path: "settings",
        name: "worksheet-settings",
        component: () => import("./worksheets/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "worksheet",
          title: "tools_meta.worksheet_prefix",
        },
      },
      {
        path: "share",
        name: "worksheet-share",
        component: () => import("./worksheets/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "worksheet",
          title: "tools_meta.worksheet_prefix",
        },
      },
      {
        path: "theming",
        name: "worksheet-theming",
        component: () =>
          import("./worksheets/[id]/theming/WorksheetThemingPage.vue"),
      },
    ],
  },
  // Dot-notation routes (not children of show layout)
  {
    path: "/worksheet/worksheets/:id/public_worksheet_responses/:responseId",
    name: "worksheet-responses-public-show",
    component: () =>
      import("./worksheets/[id].public_worksheet_responses/[responseId]/PublicWorksheetResponseDetailPage.vue"),
    meta: {
      noVisitor: true,
      title: "tools_meta.worksheet_prefix",
    },
  },
  {
    path: "/worksheet/worksheets/:id/public_worksheet_responses/new",
    name: "worksheet-responses-public-new",
    component: () =>
      import("./worksheets/[id].public_worksheet_responses/new/PublicWorksheetResponseNewPage.vue"),
    meta: {
      title: "tools_meta.worksheet_prefix",
    },
  },
  {
    path: "/worksheet/worksheets/:id/responses",
    name: "worksheet-responses-index",
    component: () =>
      import("./worksheets/[id].responses/WorksheetResponseListPage.vue"),
    meta: {
      title: "tools_meta.worksheet_prefix",
    },
  },
  {
    path: "/worksheet/worksheets/:id/responses/:responsePage",
    name: "worksheet-responses-show",
    component: () =>
      import("./worksheets/[id].responses/[responsePage]/WorksheetResponsePageDetailPage.vue"),
    meta: {
      title: "tools_meta.worksheet_prefix",
    },
  },
];
